export default {
  fetchOneStart: {
    fetchingOne: true,
    fetchedOne: false,
  },
  fetchOneFinished: {
    fetchingOne: false,
    fetchedOne: true,
  },
  fetchAllStart: {
    fetching: true,
    fetched: false,
  },
  fetchAllFinished: {
    fetching: false,
    fetched: true,
  },
  searchAllStart: {
    searching: true,
    searched: false,
  },
  searchAllFinished: {
    searching: false,
    searched: true,
  },
  updateAllStart: {
    updatingAll: true,
    updatedAll: false,
  },
  updateAllFinished: {
    updatingAll: false,
    updatedAll: true,
  },
  replaceAllFinished: {
    replacingAll: false,
    replacedAll: true,
  },
  clearAllFinished: {
    clearingAll: false,
    clearedAll: true,
  },
  clearOneFinished: {
    clearingOne: false,
    clearedOne: false,
  },
  clearListFinished: {
    clearingList: false,
    clearedList: false,
  },
  setErrorFinished: {
    errorSetting: false,
    errorSetted: true,
  },
  clearErrorFinished: {
    errorClearing: false,
    errorCleared: true,
  },
  clearSearchListFinished: {
    clearingSearchList: false,
    clearedSearchList: false,
  },
  clearFromStateFinished: {
    clearingFromStateFinished: true,
  },
  clearStateFinished: {
    clearingStateFinished: true,
  },
  updateStart: {
    updating: true,
    updated: false,
  },
  updateFinished: {
    updating: false,
    updated: true,
  },
  updateMultipleStart: {
    updatingMultiple: true,
    updatedMultiple: false,
  },
  updateMultipleFinished: {
    updatingMultiple: false,
    updatedMultiple: true,
  },
  deleteStart: {
    deleting: true,
    deleted: false,
  },
  deleteFinished: {
    deleting: false,
    deleted: true,
  },
  createStart: {
    creating: true,
    created: false,
  },
  createFinished: {
    creating: false,
    created: true,
  },
};
